import React, { useState, useRef } from "react";
import axios from "axios";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import Messages from "../../../constants/Messages";
import uRLs from "../../../utils/baseUtils";
import { useShowAlert } from "../../../context/AlertContext";

const AuthLogin = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const showAlert = useShowAlert();

     const emailInputRef = useRef(null);
    const [isBtnLoading, setBtnLoading] = useState(false);

    const email = location.state?.email || '';
    const [isLoginData, setLoginData] = useState({ email: email });
    const [error, setErrors] = useState({});
    const [errorMsg, setErrorMsg] = useState(null);
   
    const validateForm = () => {
        const errors = {};
        if (isLoginData.email === undefined || isLoginData.email === null || isLoginData.email === "") {
            errors.email = Messages.ERROR.EMPTY_EMAIL;
        } else if (isLoginData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(isLoginData.email)) {
            errors.email = Messages.ERROR.INVALID_EMAIL;
        }
        setErrors(errors);
        if (Object.keys(errors).length > 0) {
            const firstErrorField = Object.keys(errors)[0];
            switch (firstErrorField) {
                case 'email':
                    emailInputRef.current?.focus();
                    break;
                default:
                    break;
            }
        }
        return Object.keys(errors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const cleanedValue = (name === 'email')
            ? value.replace(/\s/g, '').trim().toLowerCase() : value;
        const updatedData = {
            ...isLoginData,
            [name]: cleanedValue,
        };
        setLoginData(updatedData);
    };

    const handleSendOTP = () => {
        setErrorMsg(null);
        if (!validateForm()) return;
        handleLogin();
    };

    const handleLogin = async () => {
        setBtnLoading(true);
        try {
            const response = await axios.post(`${uRLs.AUTH_URL}auth-email`, isLoginData, {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            });
            showAlert("success", Messages.SUCCESS.OTP_SEND);
            navigate("/verify", { state: { email: isLoginData.email, verifyToken: response.data.results.verifyToken, label: 'Back to Login', successRedirect: 'dashboard', failureRedirect: 'auth' } });
        } catch (error) {
            setErrorMsg(error.response?.data?.message || Messages.AUTH.OTP_FAILED);
        } finally {
            setBtnLoading(false);
        }
    };

     const handleBackLink = () => {
        navigate("/login", {
            replace: true,
            state: {
                email: isLoginData.email
            },
        });
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSendOTP();
        }
    };

    return (
        <div className="wrapper">
            <div className="section-authentication-cover">
                <div className="row g-0">
                    <div className="col-12 col-xl-7 col-xxl-8 auth-cover-left align-items-center justify-content-center d-none d-xl-flex">
                        <div className="card shadow-none bg-transparent shadow-none rounded-0 mb-0">
                            <div className="card-body">
                                <img src="/assets/images/login-images/auth-create.png" alt="Cover" className="img-fluid" width="540" />
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-xl-5 col-xxl-4 auth-cover-right align-items-center justify-content-center">
                        <div className="card rounded-0 m-3 shadow-none bg-transparent mb-0">
                            <div className="card-body p-sm-5">
                                <div className="text-center mb-3">
                                    <img src="/assets/images/logo-icon.png" width="70" alt="Login" />
                                </div>
                                <div>
                                    <h4 className="text-center mt-4 fw-400">Welcome to Negobill Portal! 👋</h4>
                                    <p className="text-center mb-4">Continue with your email ID to proceed.</p>

                                    <div className="row g-3">
                                        <div className="col-12">
                                            <label htmlFor="email" className="form-label">
                                                Email <span className="text-danger"> *</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="email"
                                                autoComplete="off"
                                                value={isLoginData.email}
                                                onChange={handleChange}
                                                ref={emailInputRef}
                                                onKeyDown={handleKeyDown}
                                            />
                                            {error.email && <div className="invalid-feedback">{error.email}</div>}
                                        </div>

                                        {errorMsg && <div className="invalid-feedback">{errorMsg}</div>}

                                        <div className="col-md-6">
                                            <a onClick={handleBackLink} className="text-blue cursor-pointer">Login using Password</a>
                                        </div>

                                        <div className="col-12 mt-3">
                                            <div className="d-grid">
                                                {isBtnLoading ? (
                                                    <button className="btn btn-primary pb-0" disabled>
                                                        <CircularProgress size={22} className="text-white" />
                                                    </button>
                                                ) : (
                                                    <button type="button" onClick={handleSendOTP} className="btn btn-primary w-100">
                                                        Send OTP
                                                    </button>
                                                )}
                                            </div>
                                        </div>



                                        {/* <div class="col-12">
                                            <div class="text-center ">
                                                <p class="mb-0">New on our platform?
                                                    <Link to="/register" className="text-blue"> Create an account</Link>
                                                </p>
                                            </div>
                                        </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AuthLogin;